export const invoicesMisc = {
  sendLink: {
    title: "إرسال رابط الفوترة",
    already: {
      title: "هذا الحجز لديه فاتورة صادرة بالفعل.",
      onlyOne: "يُسمح بـ<b>فاتورة واحدة لكل حجز</b> فقط.",
      offerPdf:
        "إن أردت، يمكننا أن نرسل إليك الآن ملف PDF للفاتورة عبر واتساب.",
    },
    openPdf: "فتح ملف PDF",
    sendWhatsapp: "إرسال الفاتورة عبر واتساب",
    sending: "جارٍ الإرسال…",
    info: {
      title: "سيُرسل رابط الفوترة إلى النزيل عبر واتساب.",
      desc: "سيُكمل النزيل بياناته الضريبية من الرابط وسيتمكن من تنزيل فاتورته الإلكترونية.",
    },
    rule: "<strong>القاعدة:</strong> لا يمكن إصدار سوى <b>فاتورة واحدة لكل حجز</b>.",
    accept: "قبول وإرسال",
    toast: {
      invoiceSent: "تم إرسال الفاتورة عبر واتساب.",
      linkSent: "تم إرسال رابط الفوترة عبر واتساب.",
    },
    warn: {
      noReservation: "لم يُعثر على معرّف الحجز بعد.",
    },
    err: {
      sendInvoiceFailed: "تعذّر إرسال الفاتورة عبر واتساب.",
      sendLinkFailed: "تعذّر إرسال الرابط.",
    },
  },
  country: {
    placeholder: "اختر دولة (اختياري)",
    noResult: "لا توجد نتائج",
  },
  adjust: {
    title: "تعديل {name}",
    type: {
      apartment: "شقة (شقق)",
      hotel: "فندق (غرف)",
      villa: "فلل",
      camping: "مخيمات",
      default: "أماكن الإقامة",
    },
    usage: "الاستخدام الحالي",
    available: "المتاح",
    unitDefault: "وحدة",
    hintReduce:
      "يُطبَّق التخفيض الآن و<b>لا</b> يترتب عليه استرداد. ستدفع أقل في الفاتورة التالية.",
    unitPriceCurrent: "سعر الوحدة الحالي",
    totalBeforeProration: "الإجمالي (قبل التقسيم النسبي)",
    prorationNote:
      "سيُطبَّق <b>تقسيم نسبي</b> عن الأيام المنقضية من الدورة.",
    confirmIncrease: "تأكيد الزيادة",
    confirmDecrease: "تأكيد التخفيض",
    err: {
      selectAmount: "اختر كمية للتعديل.",
      failed: "تعذّر إتمام العملية.",
    },
    toast: {
      added: "تمت إضافة الوحدات",
      reduced: "تم تخفيض الوحدات",
      addedDetail: "سيُطبَّق تقسيم نسبي عن الأيام المتبقية من الدورة.",
      reducedDetail: "ستدفع أقل في الفاتورة التالية (دون استرداد).",
    },
  },
  menu: {
    title: "اشتراكي",
    subtitle: "إدارة اشتراكاتك وفواتيرك وطرق الدفع",
    subscription: "اشتراكي",
    paymentMethod: "طريقة الدفع",
    invoices: "الفواتير",
  },
  custom: {
    title: "خطة مخصّصة",
    whatDoYouNeed: "ماذا تحتاج؟",
    salesContact:
      "سيتواصل معك فريق المبيعات في أقرب وقت ممكن.",
    tellUs: "أخبرنا المزيد عن مشروعك",
    sentOk: "تم الإرسال بنجاح",
    salesContactShort:
      "سيتواصل فريق المبيعات في أقرب وقت ممكن",
    contactSales: "التواصل مع المبيعات",
    err: {
      required:
        "يجب أن تحدّد ما تحتاجه حتى نتمكن من التواصل معك",
      failed: "عذرًا، تعذّرت معالجة الطلب",
    },
  },
  common: {
    cancel: "إلغاء",
    close: "إغلاق",
  },
};
